/* import __COLOCATED_TEMPLATE__ from './procedures-empty-state.hbs'; */
/* RESPONSIBLE TEAM: team-actions */
import templateOnlyComponent from '@ember/component/template-only';

interface Signature {
  Element: HTMLDivElement;
  Args: {};
  Blocks: {};
}

const ProceduresEmptyState = templateOnlyComponent<Signature>();
export default ProceduresEmptyState;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Standalone::Tasks::ProceduresEmptyState': typeof ProceduresEmptyState;
  }
}
